import React from 'react';
import { cn } from '../lib/utils';

export interface LoadingSkeletonProps {
  lines?: number;
  rows?: number;
  className?: string;
  compact?: boolean;
}

export function LoadingSkeleton({ lines, rows, className, compact = false }: LoadingSkeletonProps) {
  const count = lines ?? rows ?? 3;
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(compact ? 'space-y-2' : 'space-y-3', className)}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={cn(
            compact ? 'h-3' : 'h-4',
            'animate-pulse motion-reduce:animate-none rounded bg-surface-soft',
            i === 1 && count > 2 ? 'w-11/12' : '',
            i === count - 1 && count > 1 ? 'w-2/3' : i > 1 ? 'w-5/6' : 'w-full',
          )}
        />
      ))}
    </div>
  );
}
